export const EMPTY_PARTNER_FORM = { name_ar: "", name_en: "" };
